module.exports = __webpack_public_path__ + "img/header-engagementRingsClassic.aaf2095.jpg";